export default __webpack_public_path__ + "f583575e290fe6c14651eb87202b6155.svg";